import React, { Component } from "react";
//import Select from 'react-select'
import Icons from "../../icon";
import "./chart-header-dropdown.css"
import { InputGroup,FormControl } from "react-bootstrap";
import ButtonIcon from '../../button'
import { Table_View } from "../../../constants/internal-constants";
export class ChartHeaderDropdown extends Component {
    constructor(props) {
        super();
        this.state = ({          
            showClass:"",
        })
        this.onChangeUsageMonth = this.onChangeUsageMonth.bind(this);
    }
    totalCount() {
        return ( 
            <div className="total-count">
                 {(this.props.countData).map((val,id) => {
                    return (
                        <div className="count-wrapper" key={id}>
                            <div className="total-number"> {val.total} </div>
                            <div className="total-descr"> {val.description} </div>
                        </div>
                    )
                })}
                
            </div>  
        )
    }

    totalVal () {
        return (
            <div className="total-count">
                <div className="count-wrapper">
                    <div className="total-value"> {this.props.displayValue} </div>
                </div>                
            </div>  
        )
    }
    
    hoverOver() {
        this.setState({showClass:"showDetails"})
    }
  
    hoverLeave() {
        this.setState({showClass:""})
    }

    onChangeUsageMonth(event) {
        const { onUsageMonthSelect } = this.props;
        onUsageMonthSelect(event.label);
    }

    onGridView() {
        this.props.viewType(Table_View.Grid)
    }

    onListView() {
        this.props.viewType(Table_View.List)
    }

    render(){
        const { productDetails, haveOneIcone, iconInfo, haveDropdown, displayValue, totalCount, haveInput, oneIcon, circleIcon, haveIconInfo, circleFirstIcon, circleSecondIcon, haveLedger, selectedUsageMonth, usageMonthOptions, isMonthlySpendTitle, isUsageChartTitle }=this.props;
        return(
            <div className="header-search-container">

                <div className="header-container">
                    <div className="header-right-container">
                         <div className="header-title-container">
                            {isMonthlySpendTitle ?
                                <h1 className="header-table-cost">{this.props.spendHeaderName}</h1> : "" }
                            {isUsageChartTitle ?
                                <h1 className="header-table-cost">{this.props.usageHeaderName}</h1> : "" }
                            {haveIconInfo ?                    
                                <div className={`details-info ${this.state.showClass}`} onMouseLeave={this.hoverLeave.bind(this)} onMouseOver={this.hoverOver.bind(this)}>
                                <Icons
                                    customClassName="icon-info-circle"
                                    name={iconInfo}
                                    size="15px"                    
                                />
                                <div className="plan-details-list">
                                    {productDetails!==undefined ? productDetails.map((item,id)=><p key={id}>{item}</p>) : ""}
                                </div>
                                </div> 
                                : ""
                                    }
                         </div>       
                        {haveLedger ?
                            <div className="usage-details-legend ledger-container">
                                <div key={0}>
                                    <span >{"Statistics for the month of " + selectedUsageMonth}</span>
                                </div>
                            </div>
                            : ""
                            }
                    </div>
                    <div className="header-left-container">                        
                        {haveInput ? 
                             <InputGroup size="sm" className="request-input-header header-input">
                                <InputGroup.Text id="inputGroup-sizing-sm">
                                <Icons name="search" customClassName="icon-search" size="12px" />
                                </InputGroup.Text>
                                <FormControl
                                placeholder="Search..."
                                aria-label="Small"
                                aria-describedby="inputGroup-sizing-sm"
                                />                  
                             </InputGroup>
                             : ""
                        }
                       {circleIcon ?
                         <>
                            <ButtonIcon onClick={this.onListView.bind(this)} iconLeft={circleFirstIcon} iconSize="16px" customClassName="table-icon-list"/>
                            <ButtonIcon onClick={this.onGridView.bind(this)} iconLeft={circleSecondIcon} iconSize="16px" customClassName="table-icon-grid"/>
                         </>
                         : ""
                        }
                    </div>
                    {haveOneIcone ?
                         <Icons
                         customClassName="icon-vertical-grid"
                         name={oneIcon}
                         size="20px"    
                         containerClass="icon-grid"                
                         />
                         : ""
                    }
                </div>            
              { totalCount !== undefined ? this.totalCount() : "" }
              { displayValue !== undefined ? this.totalVal() : "" }
         </div>
        );
    }
}